import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import { joinMultipleStyle } from '../../../Utils/ScssUtils';
import '../ButtonStyle.scss';

function PrimaryButton({
    className,
    ...others
}: Omit<ButtonProps, 'variant'>): React.ReactElement {
    return (
        <Button
            className={joinMultipleStyle('buttonFilled', className)}
            variant="contained"
            {...others}
        />
    );
}

export default PrimaryButton;
